import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 2rem;
  text-align: center;
`;

const ErrorTitle = styled.h2`
  color: var(--danger-color);
  margin-bottom: 1rem;
`;

const ErrorMessage = styled.p`
  color: var(--gray-600);
  margin-bottom: 1rem;
`;

const ErrorDetails = styled.pre`
  background-color: var(--gray-100);
  padding: 1rem;
  border-radius: var(--border-radius-md);
  max-width: 600px;
  overflow-x: auto;
  text-align: left;
  font-size: 0.875rem;
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <ErrorTitle>抱歉，页面出现错误</ErrorTitle>
          <ErrorMessage>
            {this.state.error && this.state.error.toString()}
          </ErrorMessage>
          {this.state.errorInfo && (
            <ErrorDetails>
              {this.state.errorInfo.componentStack}
            </ErrorDetails>
          )}
          <button 
            onClick={() => window.location.reload()}
            style={{
              marginTop: '1rem',
              padding: '0.75rem 1.5rem',
              backgroundColor: 'var(--primary-color)',
              color: 'white',
              border: 'none',
              borderRadius: 'var(--border-radius-md)',
              cursor: 'pointer'
            }}
          >
            刷新页面
          </button>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
